import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M6.91 7.95a1.09 1.09 0 1 1 2.18 0 1.09 1.09 0 0 1-2.18 0" />
    <path
      fillRule="evenodd"
      d="M8 4.68a3.27 3.27 0 1 0 0 6.54 3.27 3.27 0 0 0 0-6.54M5.82 7.95a2.18 2.18 0 1 0 4.36 0 2.18 2.18 0 0 0-4.36 0"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M8 2.5a8.72 8.72 0 0 1 7.91 5.046.96.96 0 0 1 0 .81A8.72 8.72 0 0 1 8 13.4 8.72 8.72 0 0 1 .09 8.355a.96.96 0 0 1 0-.81A8.72 8.72 0 0 1 8 2.5m6.658 4.99A7.63 7.63 0 0 0 8 3.59a7.63 7.63 0 0 0-6.658 3.9.94.94 0 0 0 0 .92A7.63 7.63 0 0 0 8 12.31a7.63 7.63 0 0 0 6.658-3.9.94.94 0 0 0 0-.92"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEye = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="eye" {...props} />;
export default SvgEye;
